import styled from 'styled-components';

import CardGroupStyled from '../../components/CardGroup';
import HeroStyled from '../../components/Hero';
import PaginationStyled from '../../components/Pagination';
import commonPageContentStyles from '../../styles/mixins/_commonPageContentStyles';

const dataCardGroups = [
  {
    id: 1,
    title: '1',
    content: '1',
    linkUrl: '1',
    cards: [
      {
        title: 'Power BI Library',
        content:
          'It outlines the primary and secondary color palettes along with their corresponding hex codes or Pantone values, ensuring consistency across all brand materials.',
        linkUrl: '/dev-resources/powerbikit',
        image: '/images/dev-resources/dev-resources-power-bi-library@3x.jpg',
      },
      {
        title: 'Excel Library',
        content:
          'This section provides details about the primary and secondary fonts, including font families, weights, and sizes for various use cases such as headings, body text, and captions.',
        linkUrl: '/dev-resources/excel-library',
        image: '/images/dev-resources/dev-resources-excel-library@3x.jpg',
      },
      {
        title: 'ESRI Library',
        content: `Here, you'll find guidelines on logo usage, including acceptable variations such as full-color, monochrome, and reverse versions.`,
        linkUrl: '/dev-resources/esrikit',
        image: '/images/dev-resources/dev-resources-esri-library@3x.jpg',
      },
    ],
  },
  {
    id: 2,
    title: '1',
    content: '1',
    linkUrl: '1',
    cards: [
      {
        title: 'Figma Library',
        content:
          'This section outlines the design principles for icons, including style, grid system, and preferred sizes. It may also specify guidelines for icon usage in different contexts.',
        linkUrl: '/dev-resources/figma-library',
        image: '/images/dev-resources/dev-resources-figma-library@3x.jpg',
      },
    ],
  },
];
interface Props {
  className?: string;
}

const DevResourcesStructure = ({ className = '' }: Props) => (
  <div className={className}>
    <div className="content">
      <HeroStyled
        title="Dev Resources"
        subtitle={
          <>
            <p>
              Outlines the visual and stylistic elements of a brand to ensure consistency across all
              communication channels. It typically includes guidelines for logo usage, color
              palette, typography, imagery, and overall design principles.
            </p>
            <p>
              The purpose of a branding style guide is to maintain brand consistency, ensure brand
              recognition, and foster a cohesive brand identity across all touchpoints and mediums.
            </p>
          </>
        }
        category
      />
      <div>
        {dataCardGroups.map((cardGroup) => (
          <CardGroupStyled
            key={cardGroup.id}
            title={cardGroup.title}
            content={cardGroup.content}
            linkUrl={cardGroup.linkUrl}
            cards={cardGroup.cards}
            category
          />
        ))}
      </div>
      <PaginationStyled
        previousLink="/design-system/sample-dashboards"
        previous="Dashboard Examples"
      />
    </div>
  </div>
);

const DevResources = styled(DevResourcesStructure)`
  ${commonPageContentStyles}

  height: 100%;
  overflow: unset;

  .content {
    padding: 0;
  }
`;

export default DevResources;
